import type { ReactNode, ButtonHTMLAttributes } from "react";

type ButtonVariant = "gold" | "line" | "subtle";

export function GuidedButton({
  variant = "line",
  children,
  className = "",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { readonly variant?: ButtonVariant }) {
  return (
    <button type="button" className={`enrein-guided-btn enrein-guided-btn--${variant} ${className}`.trim()} {...props}>
      {children}
    </button>
  );
}

export function GuidedFlowCopy({
  title,
  kicker,
  children,
}: {
  readonly title: string;
  readonly kicker?: string;
  readonly children?: ReactNode;
}) {
  return (
    <header className="enrein-guided-flow-copy">
      {kicker ? <div className="enrein-guided-kicker">{kicker}</div> : null}
      <h2>{title}</h2>
      {children}
    </header>
  );
}

export function GuidedChip({ children, tone = "neutral" }: { readonly children: ReactNode; readonly tone?: string }) {
  return <span className={`enrein-guided-chip enrein-guided-chip--${tone}`}>{children}</span>;
}
